import { Box, Typography } from "@mui/material";

import { ScoutChatMessage } from "../hooks/useScoutChat";

export function UserMessage({ message }: { message: ScoutChatMessage }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        py: 1.5,
        px: { xs: 2, sm: 3 },
      }}
    >
      <Box
        sx={{
          maxWidth: "min(600px, 100%)",
          px: 2,
          py: 1.25,
          borderRadius: 3,
          bgcolor: "#7092CF",
          color: "white",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
        }}
      >
        <Typography variant="body1" component="div">
          {message.content}
        </Typography>
      </Box>
    </Box>
  );
}
